import {BigWinPlayingState} from '@fantasmagames/slot/src/modules/bigwin/states/BigWinPlayingState';
import {BigWinEvents} from '@fantasmagames/slot/src/modules/bigwin/BigWinEvents';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';

export class GameBigWinPlayingState extends BigWinPlayingState {
	public onEnterState(): void {
		this.emit(BigWinEvents.ON_BEFORE_BIG_WIN);

		this.module.timeUtils.createTimer(() => {
			const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;
			const win: number = logic.currentSpinWin;
			this.view.start(win, this.getBigWinLevelFromWinNumber(win));

			this.emit(BigWinEvents.STARTED);
			this.emit(BigWinEvents.COUNTUP_STARTED);
		}, BigWinPlayingState.BEFORE_BIG_WIN_PAUSE);
	}
}



// WEBPACK FOOTER //
// ./src/bigwin/states/GameBigWinPlayingState.ts